export { default as VendorQuotesV2Mspa } from "./VendorQuotesV2Mspa";